module.exports = __webpack_public_path__ + "img/1589271476.8e535cf1.jpg";